import {
  AfterViewInit,
  Component,
  EventEmitter,
  Inject,
  Input,
  OnInit,
  Output,
  PLATFORM_ID,
  ViewChild
} from '@angular/core';
import {LangChangeEvent, TranslateService} from "@ngx-translate/core";
import {IMeta, MetaService} from "@shared/services/web/meta.service";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {Router} from "@angular/router";
import {PersonService} from "@shared/services/api/person.service";
import {CredentialsService} from "@shared/services/web/credentials.service";
import {AuthenticationService} from "@app/auth/authentication.service";
import {ToastrService} from "@shared/services/web/toastr.service";
import {CookieService} from "ngx-cookie-service";
import {RedirectRouterService} from "@shared/services/web/redirect-router.service";
import {IPerson} from "@shared/model/person.model";
import {isPlatformBrowser} from "@angular/common";
import {environment} from "@env/environment";
import {GoogleOauthService} from "@shared/services/api/google-oauth.service";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {FacebookService} from "@shared/services/api/facebook.service";
import { DatalayerService } from '@app/@shared/services/web/datalayer.service';
declare var google: any;

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.scss']
})
export class RegisterComponent implements OnInit, AfterViewInit {

  googleRequest: any;
  @Output() registerOk = new EventEmitter();
  @Input() routeWizard = false;

  @ViewChild('exito', { static: false }) contenidoDelModal: any;

  error: string | undefined;
  registerForm!: FormGroup;
  isLoading = false;
  newPerson: IPerson | any;
  registerType = 'user';
  registerWithSocial = false;
  acceptTerms = false;
  acceptNotifications = false;
  showPassword = true;
  isLodingModal = false;
  tipoDeUsuario: number;
  tipoDeInversor: number;
  esInversor = false;
  userTypes: Array<any> = [];
  esCorrecto = false;

  arrayTipoInversor: any[] = [
    {
      name: 'Si',
      value: 0,
      description: 'Sí, quiero empezar a invertir',
      description_en: 'Yes, I want to start investing',
    },
    {
      name: 'No',
      value: 1,
      description: 'No, tengo otros inmuebles en cartera',
      description_en: 'No, I have other properties in my portfolio',
    },
  ];
  cookieHsUtk = '';
  constructor(
    public translateService: TranslateService,
    private metaService: MetaService,

    private router: Router,
    private formBuilder: FormBuilder,
    private registerService: PersonService,
    public credentialsService: CredentialsService,
    public authenticationService: AuthenticationService,
    private toastr: ToastrService,
    private facebookService: FacebookService,
    private modalService: NgbModal,
    private googleOauth: GoogleOauthService,
    @Inject(PLATFORM_ID) private platformId: any,
    private cookieService: CookieService,
    private redirectService: RedirectRouterService,
    private datalayerService: DatalayerService
  ) {
    this.createForm();
    this.changeMeta();
  }

  changeMeta() {
    const meta: IMeta = {
      language: this.translateService.currentLang,
      title: 'registro',
      description: 'registro_desc',
    };
    this.metaService.changeMeta(meta);

    if (this.credentialsService.isAuthenticated()) {
      this.router.navigate(['/'], { replaceUrl: true });
    }
    this.cookieHsUtk = this.cookieService.get('hubspotutk');
    this.registerService
      .getUserTypes()
      .toPromise()
      .then((data) => {
        this.userTypes = data.body;
      });
  }

  ngOnInit() {
    this.translateService.onLangChange.subscribe((event: LangChangeEvent) => {
      this.changeMeta();
    });
  }

  ngAfterViewInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      this.googleRequest = google.accounts.oauth2.initTokenClient({
        client_id: environment.GOOGLE_APP_ID,
        scope:
          'https://www.googleapis.com/auth/userinfo.profile ' +
          'https://www.googleapis.com/auth/userinfo.email ' +
          'https://www.googleapis.com/auth/plus.me',
        prompt: 'consent',
        callback: (tokenResponse: any) => {
          this.googleOauth
            .getUserInfo(tokenResponse.access_token)
            .subscribe((userResponse: any) => {
              this.signUpWithGoogle(userResponse, tokenResponse.access_token);
            });
        },
      });
    }
  }

  openLg() {
    this.modalService.open(this.contenidoDelModal, {
      size: 'lg',
      centered: true,
    });
  }

  closeModalSaveSearch() {
    // this.modalService.dismissAll();
  }

  register() {
    this.isLoading = true;

    this.newPerson = {
      first_name: this.registerForm.get('first_name')?.value,
      last_name: this.registerForm.get('last_name')?.value,
      cif: this.registerForm.get('cif')?.value,
      company_name: this.registerForm.get('company_name')?.value,
      phone: this.registerForm.get('phone')?.value
        ? {
          number: this.registerForm.get('phone')?.value,
          code_country: this.registerForm.get('code_country')?.value
            ? this.registerForm.get('code_country')?.value.phone_code
            : '34',
        }
        : null,
      user: {
        email: this.registerForm.get('email')?.value,
        password: this.registerForm.get('password')?.value,
        receiveNotifications: true,
        receiveNotificationsContent: false,
        receiveNotificationsProcesses: true,
        receiveNotificationsCommercial: false,
        experienced_investor: this.esInversor ? this.tipoDeInversor : null,
        userTypes: { id_user_type: this.tipoDeUsuario },
      },
      personType: {
        id_person_type: this.registerType === 'user' ? 1 : 2,
      },
    };

    if (this.acceptNotifications) {
      if (this.newPerson.user) {
        this.newPerson.user.receiveNotificationsContent = true;
        this.newPerson.user.receiveNotificationsCommercial = true;
      }
    }

    this.newPerson.cookieHsUtk = this.cookieHsUtk;

    this.registerService.register(this.newPerson).subscribe(
      (x) => {
        this.registerOk.emit({
          route: 'registrarse',
          email: this.newPerson.user ? this.newPerson.user.email : '',
        });

        this.datalayerService.push('sign_up', {
            form_id: 'form_register_page',
            form_name: 'Formulario Registro Página',
            form_location: 'page',
            user_type: this.tipoDeUsuario,
            page_language: this.translateService.currentLang,
            page_location: isPlatformBrowser(this.platformId) ? window.location.href : '',
            page_path: isPlatformBrowser(this.platformId) ? window.location.pathname : '',
        });

        this.openLg();
        this.redirectService.goToPage('/ingresar');
      },
      (error: any) => {
        this.toastr.error(error.error.message, 'Registro fallido');
        this.error = error;
        this.isLoading = false;
      }
    );
  }

  createForm() {
    this.registerForm = this.formBuilder.group({
      first_name: [
        '',
        Validators.compose([
          Validators.required,
          Validators.pattern('^[A-ZñÑa-zÁ-ÿ0-9\\s]+$'),
          Validators.maxLength(30),
        ]),
      ],
      last_name: [
        '',
        Validators.compose([
          Validators.required,
          Validators.pattern('^[A-ZñÑa-zÁ-ÿ0-9\\s]+$'),
          Validators.maxLength(30),
        ]),
      ],
      email: [
        '',
        Validators.compose([
          Validators.required,
          Validators.minLength(5),
          Validators.maxLength(50),
        ]),
      ],
      code_country: [null, [Validators.required]],
      phone: [
        '',
        [
          Validators.required,
          Validators.pattern(
            '^[+]?([1-9][0-9]*(?:[\\.][0-9]*)?|0*\\.0*[1-9][0-9]*)(?:[eE][+-][0-9]+)?$'
          ),
          Validators.minLength(8),
        ],
      ],
      cif: [''],
      company_name: [''],
      password: [
        '',
        Validators.compose([
          Validators.required,
          Validators.pattern(
            '^(?=[^A-Z]*[A-Z])(?=[^a-z]*[a-z])(?=\\D*\\d)[A-ZñÑa-z\\d!¡?¿$%@#£€*&^<>()+-_{}]{8,}$'
          ),
          Validators.minLength(8),
          Validators.maxLength(20),
        ]),
      ],
      reenterPassword: ['', Validators.required],
    });
  }

  updateForm(user: any) {
    this.registerForm.patchValue({
      first_name: user.firstName,
      last_name: user.lastName,
      email: user.email,
      fb_token: user.email,
    });
  }

  matchPasswords(): boolean {
    return (
      this.registerForm.get('password').value ===
      this.registerForm.get('reenterPassword').value
    );
  }

  onRegisterTypeChange() {
    this.acceptTerms = false;
    if (this.registerType === 'enterprise') {
      this.registerForm.get('cif')?.setValidators([
          Validators.maxLength(9),
          Validators.pattern('^[A-Za-z0-9_-]*$'),
        ]);
      this.registerForm
        .get('company_name')?.setValidators([Validators.required, Validators.maxLength(50)]);
    } else {
      this.registerForm.get('cif')?.setValidators(null);
      this.registerForm.get('company_name')?.setValidators(null);
    }
    this.registerForm.get('cif')?.updateValueAndValidity();
    this.registerForm.get('company_name')?.updateValueAndValidity();
    this.esInversor = false;
    this.esCorrecto = false;
  }

  onChangeType(): void {
    this.registerWithSocial = false;
    // tslint:disable-next-line:no-unused-expression
    this.registerForm.untouched;
  }

  hidePassword() {
    this.showPassword = !this.showPassword;
  }

  signUpWithGoogle(user: any, token: string) {
    if (user) {
      const person = {
        first_name: user.given_name,
        last_name: user.family_name,
        email: user.email,
        token,
        cookieHsUtk: this.cookieHsUtk,
      };
      this.registerService.registerGoogle(person).subscribe(
        (x) => {
          if (!this.routeWizard) {
            this.toastr.success(
              'Ingrese a Inviertis con sus nuevas credenciales',
              'Registro exitoso'
            );

            this.datalayerService.push('sign_up', {
                form_id: 'form_register_page',
                form_name: 'Formulario Registro Página',
                form_location: 'page',
                page_language: this.translateService.currentLang,
                page_location: isPlatformBrowser(this.platformId) ? window.location.href : '',
                page_path: isPlatformBrowser(this.platformId) ? window.location.pathname : '',
                method: 'google',
            });

            this.redirectService.goToPage('/ingresar');
          }
        },
        (error: any) => {
          this.toastr.error(error.error.message, 'Registro fallido');
          this.error = error;
          this.isLoading = false;
        }
      );
    }
  }
  async signUpWithFB() {
    this.facebookService.loginWithFacebook().then(
      (resp: any) => {
        const user: any = resp;

        if (user) {
          const person = {
            first_name: user.firstName,
            last_name: user.lastName,
            email: user.email,
            token: user.authToken,
            cookieHsUtk: this.cookieHsUtk,
          };

          this.registerService.registerFacebook(person).subscribe(
            (x) => {
              if (!this.routeWizard) {
                this.toastr.success(
                  'Ingrese a Inviertis con sus nuevas credenciales',
                  'Registro exitoso'
                );

                this.datalayerService.push('sign_up', {
                    form_id: 'form_register_page',
                    form_name: 'Formulario Registro Página',
                    page_language: this.translateService.currentLang,
                    page_location: isPlatformBrowser(this.platformId) ? window.location.href : '',
                    page_path: isPlatformBrowser(this.platformId) ? window.location.pathname : '',
                    method: 'facebook',
                });

                this.redirectService.goToPage('/ingresar');
              }
            },
            (error: any) => {
              this.toastr.error(error.error.message, 'Registro fallido');
              this.error = error;
              this.isLoading = false;
            }
          );
        }
      },
      () => {
        console.log('Inicio de sesión fallido');
      }
    );
  }

  onChangeTipoUser(event: any) {
    const  value  = (event.target as HTMLInputElement).value
    if (event === 'Invertir' || event === 'Invest') {
      this.esInversor = true;
      this.esCorrecto = false;
    } else {
      this.esInversor = false;
      this.esCorrecto = true;
    }
    for (const item of this.userTypes) {
      if (event === item.description || event === item.description_en) {
        this.tipoDeUsuario = item.id_user_type;
      }
    }
  }
  onChangeTipoInversor(event: any) {
    const  value  = (event.target as HTMLInputElement).value
    this.esCorrecto = true;
    for (const item of this.arrayTipoInversor) {
      if (event === item.description || event === item.description_en) {
        this.tipoDeInversor = item.value;
      }
    }
  }

}
